import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { map, filter, take } from 'rxjs/operators';
import { AuthStore } from '../store/auth.store';

export const authGuard: CanActivateFn = (route, state) => {
  const store = inject(AuthStore);
  const router = inject(Router);

  const status$ = toObservable(store.status);

  return status$.pipe(
    filter((status) => status !== 'init' && status !== 'loading'),
    take(1),
    map((status) => {
      if (status === 'authenticated') return true;
      router.navigate(['/auth']);
      return false;
    })
  );
};
